import React from 'react';
import AppRouter from './router/AppRouter';
import { BrowserRouter as Router } from 'react-router-dom';
import { AuthProvider } from './users/components/AuthProvider';
import ScrollToTop from './core/components/Common/ScrollToTop';
import { HelmetProvider } from 'react-helmet-async';

const App = () => {
  return (
    <HelmetProvider>
      <AuthProvider>
        <Router>
          <ScrollToTop />
          <AppRouter />
        </Router>
      </AuthProvider>
    </HelmetProvider>
  );
};

export default App;